export const COUNTRY_CODE = [{ label: "Malaysia (+60)", value: "+60" }]

export const GENERAL_SETTING = {
    PAGE_LIMIT: 10,
}

export const FOOTER_TAB_INDEX = {
    HOME: 0,
    CHAT: 1,
    CATEGORY: 2,
    MY_ACOUNT: 3,
}

export const CART_TYPE = {
    ITEM: "item",
    PACKAGE: "package",
}